//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters, mapActions } from 'vuex'
import { axiosGet } from '../../../../../axios/axios.js'
import TableServer from '../../../../../components/Table/Table.vue'

import { checkProvidableVehicleManagementAccess, createProvidableVehicle } from '../../../../../forms/Vehicle/Vehicle.js'

function formatTrueFalse (value) {
  if (value === true) {
    return 'Да'
  } else if (value === false) {
    return 'Нет'
  }
  return ''
}

export default {
  components: {
    TableServer
  },
  props: {
    organizationId: {
      type: Number,
      default: null
    },
    providable: {
      type: Boolean,
      default: null
    },
    formId: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      loading: false,
      columns: [
        {
          name: 'name',
          label: 'Название ТС',
          align: 'left',
          field: 'name',
          sortable: true
        },
        {
          name: 'gosNumber',
          label: 'ГРЗ ТС',
          align: 'left',
          field: 'gosNumber',
          sortable: true
        },
        {
          name: 'garageNumber',
          label: 'Бортовой номер ТС',
          align: 'left',
          field: 'garageNumber',
          sortable: true
        },
        {
          name: 'model',
          label: 'Марка/модель ТС',
          align: 'left',
          field: 'model',
          sortable: false
        },
        {
          name: 'vehicleType',
          label: 'Тип ТС',
          align: 'left',
          field: 'vehicleType',
          sortable: false
        },
        {
          name: 'inUse',
          label: 'ТС в эксплуатации',
          align: 'left',
          field: 'inUse',
          sortable: false,
          format: formatTrueFalse
        },
        {
          name: 'brigade',
          label: 'Текущая бригада',
          align: 'left',
          field: 'brigade',
          sortable: false
        },
        {
          name: 'employeeFIO',
          label: 'Водитель',
          align: 'left',
          field: 'employeeFIO',
          sortable: false
        },
        {
          name: 'organization',
          label: 'Организация',
          align: 'left',
          field: 'organization',
          sortable: false
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      selectedVehiclesIds: 'getSelectedVehiclesIds',
      user: 'getUser'
    }),
    providableVehicleManagementAccess: function () {
      return checkProvidableVehicleManagementAccess(this.user)
    },
    additionalUrlParams: function () {
      if (this.organizationId || this.providable != null) {
        const params = {}
        if (this.organizationId) {
          params.organizationId = this.organizationId
        }
        if (this.providable != null) {
          params.providable = this.providable
        }
        return params
      }
      return null
    },
    visibleColumns: function () {
      let columns = this.columns || []
      if (this.organizationId) {
        columns = columns.filter(column => column.name !== 'organization')
      }
      if (this.providable) {
        columns = columns.filter(column => column.name !== 'brigade' && column.name !== 'employeeFIO' && column.name !== 'garageNumber' && column.name !== 'gosNumber')
      }
      return columns.map(column => column.name)
    }
  },
  methods: {
    ...mapActions({
      setSelectedVehiclesIds: 'setSelectedVehiclesIds'
    }),
    getObjectCardUrl: function (vehicle) {
      const subType = this.providable ? 'vehicleProvided' : null
      return this.$d_getUrlObjectCard(vehicle.id, 'vehicle', subType)
    },
    onSelectItem: function (item) {
      const ids = this.selectedVehiclesIds.data
      const itemIndex = ids.indexOf(item.id)
      if (itemIndex === -1) {
        ids.push(item.id)
      } else {
        ids.splice(itemIndex, 1)
      }

      this.setSelectedVehiclesIds({
        data: ids,
        component: 'dispatcher-vehicles-tab'
      })
    },
    notifySelectedCount: function () {
      this.$q.notify({
        type: 'positive',
        message: 'Выбрано транспортных средств: ' + this.selectedVehiclesIds.data.length,
        progress: true,
        timeout: 3000
      })
    },
    onSelectAllItems: function () {
      this.loading = true

      axiosGet({
        url: '/service/delta/obj/vehicle/search?onlyIds=' + true + '&limit=1000000',
        onSuccess: (response) => {
          this.setSelectedVehiclesIds({
            data: response.data.result,
            component: 'dispatcher-vehicles-tab'
          })

          this.notifySelectedCount()
        },
        onFailure: () => {
          this.$q.notify({
            type: 'negative',
            message: 'Ошибка загрузки данных для таблицы',
            progress: true,
            timeout: 8000
          })
        }
      })
        .finally(() => {
          this.loading = false
        })
    },
    onClearSelection: function () {
      this.setSelectedVehiclesIds({
        data: [],
        component: 'dispatcher-vehicles-tab'
      })
    },
    showColumnMobile: function (col) {
      const val = col.value
      const hasColumnValue = val != null && !!val && val.length > 0
      return col.showAlways || hasColumnValue
    },

    onCreateProvidableVehicle: function () {
      const objectParams = {
        inUse: true
        // organization: organizationId,
        // vehicleType: vehicleTypeId
      }
      if (this.organizationId) {
        objectParams.organization = this.organizationId
      }

      const createConfig = { objectParams }
      createProvidableVehicle(this, createConfig, objectId => {
        this.registryCmp.onObjectAdded(objectId)
      })
    }
  }
}

